import * as React from 'react';
import type { SVGProps } from 'react';
const SvgText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-label="Text"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4.75 4.75v.493a.75.75 0 0 1-1.5 0V4.2a.95.95 0 0 1 .95-.95h11.6a.95.95 0 0 1 .95.95v1.043a.75.75 0 0 1-1.5 0V4.75h-4.5v10.306h.829a.75.75 0 1 1 0 1.5H8.42a.75.75 0 0 1 0-1.5h.829V4.75z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgText;
